<template>
	<v-dialog
		persistent
		max-width="600"
		v-model="dialog"
	>
		<v-card v-if="e">
			<v-card-title>
				<span>Atlaso aprašymas</span>
			</v-card-title>
			<v-card-text>
				<v-form ref="form">
					<template v-for="(field) in fields">
						<template v-if="field.type == 'textarea'">
							<v-textarea
								:label="field.title"
								:key="getKey(field)"
								hide-details
								v-model="model[field.key]"
								filled
								class="body-2 mt-2"
								:rules="field.rules"
								:disabled="Boolean(field.disabledOnUpdate && e.id)"
								:height="field.height || 90"
								no-resize
								:placeholder="field.placeholder"
							></v-textarea>
						</template>
						<template v-else-if="field.type == 'select'">
							<v-select
								:label="field.label"
								:key="getKey(field)"
								hide-details
								v-model="model[field.key]"
								filled
								class="body-2 mt-2"
								:rules="field.rules"
								:disabled="Boolean(field.disabledOnUpdate && e.id)"
								:items="field.items"
								item-value="key"
								item-text="name"
								:placeholder="field.placeholder || 'Pasirinkite reikšmę'"
							></v-select>
						</template>
						<template v-else>
							<v-text-field
								:label="field.title"
								:key="getKey(field)"
								hide-details
								v-model="model[field.key]"
								filled
								class="body-2 mt-2"
								:rules="field.rules"
								:disabled="Boolean(field.disabledOnUpdate && e.id)"
								:placeholder="field.placeholder"
							></v-text-field>
						</template>
					</template>
				</v-form>
			</v-card-text>
			<v-card-actions class="mx-4 pb-5">
				<v-btn
					color="blue darken-1"
					text
					v-on:click="save"
					outlined
					small
					:loading="saveInAction"
				>
					{{actionTitle}}
				</v-btn>
				<v-btn
					color="blue darken-1"
					text
					v-on:click="closeDialog"
					outlined
					small
					:disabled="saveInAction"
				>
					Atšaukti
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import AtlasHelper from "../helpers/AtlasHelper";

	export default {
		data: function(){
			var data = {
				dialog: false,
				saveInAction: false,
				e: null,
				fields: [{
					title: "Pavadinimas",
					key: "title",
					rules: [v => !!v || "Laukas privalomas"]
				},{
					title: "Trumpas aprašymas",
					key: "shortDescription",
					type: "textarea",
					rules: [v => !!v || "Laukas privalomas"]
				/*
				},{
					title: "Aprašymas",
					key: "description",
					type: "textarea",
					height: 125
				*/
				},{
					title: "Raktažodžiai",
					key: "keywords",
					placeholder: "Raktažodžiai, atskirti kableliais"
				},{
					title: "Tipas",
					key: "atlasType",
					type: "select",
					rules: [v => !!v || "Laukas privalomas"],
					items: AtlasHelper.getAtlasTypes(),
					disabledOnUpdate: true,
					placeholder: "Atlaso tipas"
				}],
				model: {},
				actionTitle: ""
			};
			return data;
		},
		created: function(){
			this.iteration = 0;
			this.$vBus.$on("show-atlas-summary-form", this.showAtlasForm);
		},
		beforeDestroy: function(){
			this.$vBus.$off("show-atlas-summary-form", this.showAtlasForm);
		},
		methods: {
			closeDialog: function(){
				this.e = null;
				this.dialog = false;
			},
			save: function(){
				var formValid = this.$refs.form.validate();
				if (formValid) {
					var def;
					if (this.e.id) {
						def = AtlasHelper.createOrUpdateAtlas(this.model, this.e.id);
					} else {
						def = AtlasHelper.createOrUpdateAtlas(this.model);
					}
					def.then(function(response){
						this.saveInAction = false;
						this.dialog = false;
						if (this.e.callback) {
							this.e.callback(response);
						}
					}.bind(this), function(e){
						var message;
						if (e.message == "The user exceeds the atlas creation limit." || e.message == "The user exceeds the atlas size limit.") {
							message = "Klaida! Jūs viršijote jums skirtą resursų limitą.";
						}
						this.$vBus.$emit("show-message", message || "error");
						this.saveInAction = false;
					}.bind(this));
					this.saveInAction = true;
				}
			},
			getKey: function(field){
				var key = field.key + "-" + this.iteration; // Svarbu turėti unikalią reikšmę? Kitaip pvz. turime `invalid` raudoną lauką... Uždarome dialog'ą... Vėl atidarome dialog'ą... Laukas vis dar `invalid` raudonas?..
				return key;
			},
			showAtlasForm: function(e){
				this.iteration += 1;
				var actionTitle = "Išsaugoti";
				if (!e) {
					e = {};
				}
				if (!e.id) {
					actionTitle = "Kurti naują atlasą";
				}
				this.e = e;
				var model = {},
					val;
				this.fields.forEach(function(field){
					val = null;
					if (e.data) {
						if (e.data[field.key]) {
							val = e.data[field.key];
						}
					}
					model[field.key] = val;
				}.bind(this));
				this.model = model;
				this.actionTitle = actionTitle;
				this.dialog = true;
			}
		}
	}
</script>